module.exports = __webpack_public_path__ + "static/media/Horn-antenna-used.9f493741.ppm";